import { render, staticRenderFns } from "./TenantIndex.vue?vue&type=template&id=5bbb169a&"
import script from "./TenantIndex.vue?vue&type=script&lang=js&"
export * from "./TenantIndex.vue?vue&type=script&lang=js&"
import style0 from "./TenantIndex.vue?vue&type=style&index=0&id=5bbb169a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports